/* Hook encargado de crear o modificar  la reserva

Autor: Benjamín León
Fecha: 2024-10-01
*/
import { useState } from 'react'

import { normalizeDate } from '../utils/utils.ts'
import PurchaseDto from '../interfaces/PurchaseDto.ts'
import { customPost } from '../utils/customFetch.ts'

import { makeUrlPurchaseCrea } from './connectionData.tsx'

const usePurchaseCrea = () => {
  const [errorPurchaseCrea, setErrorPurchaseCrea] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const purchaseCrea = async (purchase: PurchaseDto) => {
    setLoading(true)

    try {
      const id = await updateDatabase(purchase)
      setErrorPurchaseCrea(null)

      return id
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorPurchaseCrea(err)
      } else {
        setErrorPurchaseCrea(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }
  const updateDatabase = async (purchase: PurchaseDto): Promise<string> => {
    const apiUrl = makeUrlPurchaseCrea()
    // Tenemos que cambiarle las fechas a los costos

    ;(purchase.expenses ?? []).forEach((element) => {
      element.date = normalizeDate(element.date)
    })

    purchase.date = normalizeDate(purchase.date)

    // Determine if this is an update (has _id) or new purchase
    const isUpdate = !!purchase._id

    // Prepare the DTO for the API
    const purchaseDto: PurchaseDto = {
      ...purchase,
      // For new purchases, set number to 0 (server will assign)
      // For updates, keep the existing number
      number: isUpdate ? purchase.number : 0,
      // Ensure expenses are included
      expenses: purchase.expenses || [],
    }

    console.log(
      `Purchase ${isUpdate ? 'update' : 'create'} with number: ${purchaseDto.number}, expenses: ${purchaseDto.expenses.length}`
    )

    const res = await customPost<{ _id: string }>(apiUrl, purchaseDto)

    return res._id
  }

  // Exponemos estas variables al exterior
  return { errorPurchaseCrea, loading, purchaseCrea }
}
export default usePurchaseCrea
